<template>
    <div class="login-component-content"
        :class="[{ fixedLogin: isFixed }]"
        :style="getImgWrapperStyle"
        @click="rePortLoginComponent()">
        <div class="img-wrapper">
            <img class="login-image"
                :src="getPicUrl(activityComponentObj && activityComponentObj.jsonField && activityComponentObj.jsonField.componentBackgroundImage)">
            <div class="login-register"
                :style="getBackgroundStyle">
                <div class="login-register-inner">
                    <div class="avatar">
                        <img class="avatar-image"
                            :src="activityComponentObj && activityComponentObj.jsonField && activityComponentObj.jsonField.componentIcon === 'black-avatar' ? require('../../../../../static/image/activityManage/black-avatar.svg') : require('../../../../../static/image/activityManage/white-avatar.svg')">
                    </div>
                    <template v-if="loginType==='Alipay'">
                        <div @click="aliPayJumpLogin">
                            登录 | 注册
                        </div>
                    </template>
                    <template v-if="loginType==='wechat'">
                        <!-- 扫小程序码进入微信小程序环境 -->
                        <div v-if="miniProgramFlag && !isLoginFlag"
                            @click="wxJumpLogin">
                            登录 | 注册
                        </div>
                        <div v-if="isLoginFlag">
                            {{ limitText(miniNickName) }}
                        </div>
                        <!-- 这里的登录注册为了受getBackgroundStyle 样式控制，然后wx-open-launch-weapp里面的登录注册覆盖展示在此处登录注册上面，点击去拉起授权登录 -->
                        <div v-if="!miniProgramFlag && !isLoginFlag">登录 | 注册</div>
                        <!-- 微信提供的一个 开放标签，用于在 H5 页面中唤起微信小程序 -->
                        <wx-open-launch-weapp v-if="!miniProgramFlag && !isLoginFlag"
                            id="launch-btn"
                            :username="hiHonorWxAppId"
                            :env-version="envVersion"
                            :path="`pages/tabBar/index/index?activityUrl=${encodeURIComponent(activityUrl)}`"
                            class="launch-mask">
                            <script type="text/wxtag-template">
                                <div style="{{getBackgroundStyleStr}}">登录 | 注册</div>
                            </script>
                        </wx-open-launch-weapp>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// loginType=wechat/alipay  微信环境/支付宝环境  miniProgramFlag=true/false 微信、支付宝小程序环境/微信、支付宝浏览器环境
import wx from 'weixin-js-sdk';
import { config as configEnv } from '../../../../commons/config.js';
import { config } from '@/api/config.js';
import utils from '../../../../utils/comUtils.js';
import { getEnvMark, getWxSDKAuth } from '../common-methods/utils';
import { EnvMark } from '../lucky-draw/common/global-variable.js';
export default {
  components: {},
  props: {
    activityComponentObj: {
      type: Object,
      default: () => {
        return {};
      },
    },
    // 是否登录
    isLoginFlag: {
      type: Boolean,
      default: true,
    },
    // 登录类型
    loginType: {
      type: String,
      default: '',
    },
    // 登录如果配置在列表的最后一个，则固定悬浮在页面底部，配置在列表其他位置，则不悬浮
    isFixed: {
      type: Boolean,
      default: false,
    },
    activityCode: {
      type: String,
      default: '',
    },
    // 活动链接
    activityUrl: {
      type: String,
      default: '',
    },
    // 是否需要获取微信授权
    isNeedWxAuth: {
      type: Boolean,
      default: true,
    },
    miniNickName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      miniProgramFlag: true, // 判断是否在小程序环境内打开
      hiHonorWxAppId: config.otherConfig.hiHonorWxAppId,
      envVersion: configEnv.env === 'pro' ? 'release' : 'trial',
    };
  },
  computed: {
    getBackgroundStyle() {
      const json = (this.activityComponentObj && this.activityComponentObj.jsonField) || {};
      return {
        'background-color': json.loginRegisterBackgroundColor || '#000000',
        color: json.loginRegisterFontColor || '#FFFFFF',
        'font-size': json.loginRegisterFontSize ? json.loginRegisterFontSize + 'px' : '10px',
      };
    },
    getImgWrapperStyle() {
      const json = (this.activityComponentObj && this.activityComponentObj.jsonField) || {};
      return {
        'padding-left': json.componentLeftMargin ? json.componentLeftMargin + 'px' : '0px',
        'padding-top': json.componentTopMargin ? json.componentTopMargin + 'px' : '0px',
      };
    },
    getBackgroundStyleStr() {
      const json = (this.activityComponentObj && this.activityComponentObj.jsonField) || {};
      return `background-color: ${json.loginRegisterBackgroundColor || '#000000'};
            color: ${json.loginRegisterFontColor || '#FFFFFF'};
            font-size: ${json.loginRegisterFontSize ? json.loginRegisterFontSize + 'px' : '10px'};
            white-space: nowrap;
            font-weight: 400;
            display: flex;
            align-items: center;`;
    },
  },
  created() {
    try {
      const env = getEnvMark();
      this.miniProgramFlag = env === EnvMark.wechatMp || env === EnvMark.alipayMp;
      // 微信H5场景，需要获取开放标签的权限
      if (env === EnvMark.wechatH5 && this.isNeedWxAuth) {
        getWxSDKAuth();
      }
    } catch (err) {
      // 若上述方法出错，则使用备用方法
      this.miniProgramFlag = window.__wxjs_environment === 'miniprogram';
    }
  },
  methods: {
    limitText(str, len = 11) {
      if (!str) return '';
      return str.length > len ? str.slice(0, len) + '...' : str;
    },
    rePortLoginComponent() {
      const params = {
        actionCode: '400070004',
        actionName: '点击登入控件',
        content: {
          title: '点击登入控件',
          activityCode: this.activityCode,
        },
      };
      console.log('上报参数', params);
      utils.handleBatchReport(this, params);
    },
    // 获取图片地址
    getPicUrl(data) {
      if (data) {
        return this.$utils.getImageUrl(JSON.parse(data).file);
      }
    },
    // 扫小程序码进入微信小程序环境，拉起登录方法 webview内跳转首页登录
    wxJumpLogin() {
      console.log('活动管理-邀请有礼--this.activityUrl===========>', this.activityUrl);
      // h5点击登陆后向小程序传参方便登陆成功后使用该标识再次跳转到当前h5页面
      wx.miniProgram.postMessage({
        h5LoginToMiniFlag: !this.isLoginFlag || true,
      });
      wx.miniProgram.reLaunch({
        url: '/pages/tabBar/index/index?activityUrl=' + encodeURIComponent(this.activityUrl),
        success: () => {
          // 清空缓存
          sessionStorage.setItem('activityListId', '');
        },
        fail: (res) => {
          console.log('活动管理-邀请有礼-loginComponent--微信，跳转回小程序的页面fail', res);
        },
      });
    },
    // 支付宝环境跳转登录
    aliPayJumpLogin() {
      //在支付宝小程序环境打开
      if (this.miniProgramFlag) {
        console.log('活动管理-邀请有礼-支付宝小程序环境-this.activityUrl', this.activityUrl);
        loadAlipayWebViewScript().then(() => {
          my.postMessage({
            activityUrl: encodeURIComponent(this.activityUrl),
          });
          my.reLaunch({
            url: '/pages/tabBar/index/index?activityUrl=' + encodeURIComponent(this.activityUrl),
            success: () => {
              // 清空缓存
              sessionStorage.setItem('activityListId', '');
            },
            fail: (res) => {
              console.log('活动管理-邀请有礼-支付宝，跳转回小程序的页面fail', res);
            },
          });
        });
      } else {
        //在支付宝内部浏览器打开
        const templeQuery = encodeURIComponent(this.activityUrl);
        const query = encodeURIComponent(`activityUrl=${templeQuery}`);
        console.log('活动管理-邀请有礼-支付宝内部浏览器打开-query', query);
        window.location.href = 'alipays://platformapi/startapp?appId=2021002121684220&page=pages/tabBar/index/index&query=' + query;
        // 清空缓存
        sessionStorage.setItem('activityListId', '');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.login-component-content {
  height: auto;
  overflow: hidden;
}
.login-register-inner {
  position: relative;
  display: flex;
  align-items: center;
}
.launch-mask {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0;
  z-index: 99999;
}
.login-register {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 7px 21px;
  border-radius: 100px;
  font-size: 12px;
  color: #ffffff;
}
.login-image {
  width: 100%;
  height: 60px;
  display: block; // 加这一行就能去掉图片下方空白
}
.img-wrapper {
  position: relative;
}
.fixedLogin {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
}
.avatar {
  width: 12px;
  height: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 4px 2px 0;
  .avatar-image {
    width: 100%;
    height: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/activityManagementComponents/loginComponent.vue